module.exports = __webpack_public_path__ + "static/media/Spices-stall-India_mobile.d4cc68e2.jpg";